import { flagState } from '@mail/flags';
import { FLAGS_MAP } from 'reactApp/modules/mailFlags/constants';

export const HAS_CARD_FLAG_SYNC_STORAGE_KEY = 'cloud-user-has-binded-card-sync';

export const {
    getFlagData: getHasCardFlagData,
    isFlagExist: isHasCardFlagExist,
    updateFlag: updateHasCardFlag,
} = flagState<typeof FLAGS_MAP>({
    flagKey: FLAGS_MAP['608'],
    defaultState: true,
});

export const getHasCardFlag = async (): Promise<boolean> => {
    const isHasCardFlagExists = await isHasCardFlagExist();
    if (!isHasCardFlagExists) {
        return true;
    }

    const hasCardFlagData = await getHasCardFlagData();

    return hasCardFlagData?.state ?? true;
};
